export enum VisibilityState {
	VISIBLE = 'visible',
	INDETERMINATE = 'indeterminate',
	HIDDEN = 'hidden',
}
